module.exports = __webpack_public_path__ + "img/public/SiteIcons/listCloseIcon.svg?7198e819";